import { render, staticRenderFns } from "./game_room_bill.vue?vue&type=template&id=ad31c8a8&scoped=true"
import script from "./game_room_bill.vue?vue&type=script&lang=js"
export * from "./game_room_bill.vue?vue&type=script&lang=js"
import style0 from "./game_room_bill.vue?vue&type=style&index=0&id=ad31c8a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad31c8a8",
  null
  
)

export default component.exports